import * as productOrder from '../modules/product-order';
import * as stickyProductOrder from '../modules/sticky-product-order';

export default {
  init() {
    // JavaScript to be fired on all pages
    productOrder.init();
    stickyProductOrder.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js